const initialState = {
    recentChannels: [],
}
const RecentChannels = (state = initialState, action = {}) => {
    switch (action.type) {
        case 'setRecentChannels': {
            return {
                ...state,
                recentChannels: action.recentChannels || [],
            }
        }
        default:
            return state;
    }
}
export default RecentChannels;


// WEBPACK FOOTER //
// ./src/reducer/RecentChannels.js